import { render, staticRenderFns } from "./RecentTickets.vue?vue&type=template&id=2f004e34&scoped=true&"
import script from "./RecentTickets.vue?vue&type=script&lang=js&"
export * from "./RecentTickets.vue?vue&type=script&lang=js&"
import style0 from "./RecentTickets.vue?vue&type=style&index=0&id=2f004e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f004e34",
  null
  
)

export default component.exports